import loadable from "@loadable/component";
import LinearProgress from "@material-ui/core/LinearProgress";

/**
 * Dynamically loaded version of `SystemUsersPage`.
 */
const LoadablePage = loadable(
  () => import(/* webpackChunkName: "SystemUsers" */ "."),
  {
    fallback: <LinearProgress />,
  }
);

export default LoadablePage;
